/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecreateStockupsRequest
 */
export interface RecreateStockupsRequest {
    /**
     * 
     * @type {Date}
     * @memberof RecreateStockupsRequest
     */
    date: Date;
}

/**
 * Check if a given object implements the RecreateStockupsRequest interface.
 */
export function instanceOfRecreateStockupsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;

    return isInstance;
}

export function RecreateStockupsRequestFromJSON(json: any): RecreateStockupsRequest {
    return RecreateStockupsRequestFromJSONTyped(json, false);
}

export function RecreateStockupsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecreateStockupsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
    };
}

export function RecreateStockupsRequestToJSON(value?: RecreateStockupsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': (value.date.toISOString().substr(0,10)),
    };
}

